import * as React from "react";

import { Box, Link, makeStyles, Theme, Typography } from "@material-ui/core";

import { useMerchantModel } from "client/hooks";
import { useNormalizedBrandPaletteValues } from "client/hooks/useNormalizedBrandThemeValues";
import { logAmplitudeEvent } from "client/lib/amplitude";

const useStyles = makeStyles((theme: Theme) => {
  const { gray30 } = useNormalizedBrandPaletteValues(theme);

  return {
    subtitle: {
      color: gray30,
      marginBottom: theme.spacing(2),
    },
  };
});

export const BusinessAddressHelperText: React.FC = () => {
  const classes = useStyles();

  const { merchant } = useMerchantModel();

  if (merchant.companyInformation.registeredCountry.value === "New Zealand") {
    return (
      <Box className={classes.subtitle}>
        <Typography variant="caption">
          {"Business address (listed on your NZ Business Number Register)"}
        </Typography>
        <Typography>{}</Typography>
        <Typography variant="caption">
          {"You can check your NZBN business details "}
          <Link
            href="https://companies-register.companiesoffice.govt.nz/"
            rel="noopener noreffer"
            target="_blank"
            onClick={() => {
              logAmplitudeEvent(
                "REDESIGN_ADD_YOUR_STORE",
                "clicked_nzbn_register_link"
              );
            }}
          >
            here
          </Link>
        </Typography>
      </Box>
    );
  }
  return null;
};
